/**
 * CarrierMark — a small, brand-recognizable badge per carrier so carriers are
 * easy to spot in lists. Uses each carrier's brand COLOURS + short monogram
 * (not the exact copyrighted logos); brand colours are fixed (they don't theme).
 * Unknown codes fall back to a neutral monogram. `showName` appends the
 * humanized carrier name for places that don't already show it.
 */
import { humanizeCode } from "../../lib/format.js";

const MARKS: Record<string, { short: string; cls: string; name: string }> = {
  GLS: { short: "GLS", cls: "gls", name: "GLS" },
  DPD_SI: { short: "DPD", cls: "dpd", name: "DPD" },
  DPD: { short: "DPD", cls: "dpd", name: "DPD" },
  DHL_EXPRESS: { short: "DHL", cls: "dhl", name: "DHL Express" },
  DHL: { short: "DHL", cls: "dhl", name: "DHL Express" },
  FEDEX: { short: "Fx", cls: "fedex", name: "FedEx" },
};

export function CarrierMark({
  code,
  showName = false,
  size = 22,
}: {
  code?: string | null;
  showName?: boolean;
  size?: number;
}) {
  const m = code ? MARKS[code] : undefined;
  const short = m?.short ?? (code ? humanizeCode(code).slice(0, 3) : "—");
  const cls = m?.cls ?? "generic";
  const name = m?.name ?? (code ? humanizeCode(code) : "Unrouted");
  return (
    <span className="carrier-mark-wrap">
      <span
        className={`carrier-mark carrier-mark--${cls}`}
        style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
        title={name}
        aria-hidden={showName || undefined}
        aria-label={showName ? undefined : name}
      >
        {short}
      </span>
      {showName && <span className="carrier-mark__name">{name}</span>}
    </span>
  );
}
